<template>
    <div>
        <v-text-field-filled
            v-model="search_"
            label="Rechercher"
            density="compact"
            outlined
            single-line
            hide-details
            color="primary"
            clearable
            @click:clear="search_ = ''"
            @keypress.enter="keypressEnter"
            @update:model-value="updatedFilter"
        >
            <template #append-inner>
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    offset-y
                    left
                    bottom
                    elevation="1"
                >
                    <template v-slot:activator="{ props }">
                        <v-btn-icon
                            elevation="0"
                            icon="$tune"
                            size="small"
                            style="margin-top: -2px"
                            v-bind="props"
                            data-cy="planFilterBar-dialog"
                        />
                    </template>

                    <v-card
                        :class="{ 'pa-3 pb-0': true, 'mt-3': $vuetify.display.mobile }"
                        elevation="1"
                        :style="{ width: !$vuetify.display.mobile ? '700px' : undefined }"
                    >
                        <v-row no-gutters>
                            <v-col cols="12">
                                <h3>Filtres</h3>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="py-2">
                            <v-col
                                :cols="$vuetify.display.mobile ? '12' : '4'"
                                :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                data-cy="scopeFilterBar-taxSystem"
                            >
                                <v-select-filled
                                    v-model="transactionType_"
                                    label="Filtrer par transaction"
                                    :items="transactionTypes"
                                    :hide-details="true"
                                    @update:model-value="updatedFilter"
                                />
                            </v-col>
                            <v-col
                                :cols="$vuetify.display.mobile ? '12' : '4'"
                                :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                data-cy="scopeFilterBar-taxSystem"
                            >
                                <v-select-filled
                                    v-model="vatType_"
                                    label="Filtrer par type de TVA"
                                    :items="vatTypes"
                                    :hide-details="true"
                                    @update:model-value="updatedFilter"
                                />
                            </v-col>
                            <v-col
                                :cols="$vuetify.display.mobile ? '12' : '4'"
                                :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                data-cy="scopeFilterBar-taxSystem"
                            >
                                <v-select-filled
                                    v-model="vatOperation_"
                                    label="Filtrer par opération de TVA"
                                    :items="vatOperationTypes"
                                    :hide-details="true"
                                    @update:model-value="updatedFilter"
                                />
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="py-2">
                            <v-col
                                :cols="$vuetify.display.mobile ? '12' : '4'"
                                :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                data-cy="scopeFilterBar-taxSystem"
                            >
                                <v-select-filled
                                    v-model="thirdParty_"
                                    label="Filtrer par tiers"
                                    :items="thirdParties"
                                    :hide-details="true"
                                    @update:model-value="updatedFilter"
                                />
                            </v-col>
                            <v-col
                                :cols="$vuetify.display.mobile ? '4' : '3'"
                                :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                data-cy="planFilterBar-user"
                            >
                                <v-checkbox
                                    v-model="lettering_"
                                    label="À lettrer"
                                    density="compact"
                                    @update:model-value="updatedFilter"
                                />
                            </v-col>
                            <v-col
                                :cols="$vuetify.display.mobile ? '4' : '3'"
                                :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                data-cy="planFilterBar-user"
                            >
                                <v-checkbox
                                    v-model="publish_"
                                    label="Publié"
                                    density="compact"
                                    @update:model-value="updatedFilter"
                                />
                            </v-col>
                            <v-col
                                :cols="$vuetify.display.mobile ? '4' : '2'"
                                :class="$vuetify.display.mobile ? 'pa-1' : 'px-1'"
                                data-cy="planFilterBar-user"
                            >
                                <v-checkbox
                                    v-model="default_"
                                    label="Par défaut"
                                    density="compact"
                                    @update:model-value="updatedFilter"
                                />
                            </v-col>
                        </v-row>
                        <v-divider />
                        <v-card-actions class="d-flex justify-space-between">
                            <v-btn-reset
                                @click.stop="clearMenu()"
                                data-cy="scopeFilterBar-resetFilter"
                                size="small"
                            >
                            </v-btn-reset>
                            <v-btn
                                @click="menu = false"
                                data-cy="scopeFilterBar-validate"
                                size="small"
                                variant="tonal"
                            >
                                Valider
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </template>
        </v-text-field-filled>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Model, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { 
    thirdParties, 
    transactionTypes, 
    vatOperationTypes, 
    vatTypes 
} from "@/services/accountableAccountServices";

@Component({
    emits: ["updated-filter","keypress-enter"],
})
export class AccountableAccountFilter extends Vue {
    /** Inputs */

    @Model({ name: "search" }) search_;

    @Model({ name: "transactionType" }) transactionType_;

    @Model({ name: "vatOperation" }) vatOperation_;

    @Model({ name: "vatType" }) vatType_;

    @Model({ name: "thirdParty" }) thirdParty_;

    @Model({ name: "lettering" }) lettering_;

    @Model({ name: "publish" }) publish_;

    @Model({ name: "default" }) default_;

    @Model({ name: "activeFilters" }) activeFilters_;

    menu = false;

    get thirdParties() {
        const thirdPartiesArray = [
            { value: "", title: "" }, 
            ...Object.entries(thirdParties).map(([value, title]) => ({ value, title }))
        ];
        return thirdPartiesArray;
    }

    get transactionTypes() {
        const transactionTypesArray = [
            { value: "", title: "" }, 
            ...Object.entries(transactionTypes).map(([value, title]) => ({ value, title }))
        ];
        return transactionTypesArray;
    }

    get vatOperationTypes() {
        const vatOperationTypesArray = [
            { value: "", title: "" }, 
            ...Object.entries(vatOperationTypes).map(([value, title]) => ({ value, title }))
        ];
        return vatOperationTypesArray;
    }

    get vatTypes() {
        const vatTypesArray = [
            { value: "", title: "" }, 
            ...Object.entries(vatTypes).map(([value, title]) => ({ value, title }))
        ];
        return vatTypesArray;
    }

    keypressEnter() {
        this.$emit("keypress-enter");
    }

    updatedFilter() {
        this.$emit("updated-filter");
    }

    clearMenu() {
        this.search_ = "";
        this.lettering_ = false;
        this.publish_ = false;
        this.default_ = false;
        this.transactionType_ = "";
        this.vatOperation_ = "";
        this.vatType_ = "";
        this.thirdParty_ = "";
        this.updatedFilter()
    }

    @Watch('transactionType')
    @Watch('vatOperationType')
    @Watch('vatType')
    @Watch('thirdParty')
    @Watch('lettering')
    @Watch('publish')
    @Watch('default')
    setActive() {
        if(this.transactionType_ || this.vatOperation_ || this.vatType_ || 
           this.thirdParty_ || this.lettering_ || this.publish_ || this.default_ ) {
            this.activeFilters_ = true
        } else {
            this.activeFilters_ = false
        }
    }
}

export default toNative(AccountableAccountFilter);
</script>
